import type { M365AcquisitionsNetworkLog } from "owa-graph-schema";
import { getAddinNetworkLogs } from "./networkLogCollector";

// This is a wrapper over a function in a different file since the file does not support both exports and lazy exports
// due to es-lint rules
export function getM365AcquisitionsDiagnosticDetails(): M365AcquisitionsNetworkLog[] {
    return getAddinNetworkLogs();
}
